var irreducible = require('./irreducible');
var isNumber = require('./isNumber');

module.exports = irreducible('Number', isNumber);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/Number.js
 ** module id = 731
 ** module chunks = 0
 **/